import { Card, CardContent, CardHeader } from "@/components/ui/card";
import type { OrderProceduresStepResult } from "@/types/classification";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import DebugInfoJsonViewer from "./DebugInfoJsonViewer";

interface OrderProcedureStepResultCardProps {
  result: OrderProceduresStepResult;
}

export function OrderProcedureStepResultCard({ result }: OrderProcedureStepResultCardProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <Card className="rounded-md border bg-muted/30">
      <CardHeader>
        <div className="flex items-center gap-2">
          <button
            className="flex items-center gap-2 w-full text-left focus:outline-none"
            onClick={() => setExpanded((prev) => !prev)}
            type="button"
          >
            {expanded ? <ChevronDown className="h-4 w-4 mr-2" /> : <ChevronRight className="h-4 w-4 mr-2" />}
            <span className="font-medium">Order Procedures Step Result</span>
          </button>
        </div>
      </CardHeader>
      {expanded && (
        <CardContent className="space-y-4">
          <div>
            <div className="font-semibold mb-1">Procedures</div>
            <div className="flex flex-wrap gap-2">
              {result.procedures && result.procedures.length > 0 ? (
                result.procedures.map((proc) => (
                  <span
                    key={proc.code}
                    className="inline-block bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-100 rounded-full px-3 py-1 text-sm font-medium"
                  >
                    {proc.code} - {proc.description}
                  </span>
                ))
              ) : (
                <span className="text-muted-foreground">No procedures found</span>
              )}
            </div>
          </div>
          {result.debugInfo && (
            <div>
              <div className="font-medium">Debug Info</div>
              <DebugInfoJsonViewer debugInfo={result.debugInfo} />
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}

export default OrderProcedureStepResultCard;
